import React, { useEffect, useState } from 'react';
import { Card, Typography, Grid, Divider } from 'antd';
import { DownOutlined, RightOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import TemplateUploadCTA from './TemplateUploadCTA';

const { Paragraph, Text, Link } = Typography;
const { useBreakpoint } = Grid;

export default function NoteTypeTemplatesGuidance({ onNewTemplate, onSwitchToStandard, collapsed = false }) {
  const { t } = useTranslation();
  const screens = useBreakpoint();
  const [isCollapsed, setIsCollapsed] = useState(Boolean(collapsed));

  useEffect(() => {
    setIsCollapsed(Boolean(collapsed));
  }, [collapsed]);

  const toggleCollapsed = () => setIsCollapsed(prev => !prev);

  // Mobile: show only the upload CTA (no card, no guidance body)
  if (screens.xs) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', padding: 8 }}>
        <TemplateUploadCTA onNewTemplate={onNewTemplate} />
      </div>
    );
  }

  return (
    <Card
      size="default"
      style={{ borderRadius: 8, background: '#fafafa' }}
      styles={{ body: { padding: 8 } }}
    >
      <div
        data-testid="templates-guidance-title"
        onClick={toggleCollapsed}
        style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', userSelect: 'none' }}
      >
        {isCollapsed ? <RightOutlined style={{ color: '#999' }} /> : <DownOutlined style={{ color: '#999' }} />}
        <Paragraph style={{ margin: 0 }}>
          <Text strong>{t('note_templates.create_guidance_title')}</Text>
        </Paragraph>
      </div>
      <div
        data-testid="templates-guidance-body"
        style={{
          color: '#666',
          overflow: 'hidden',
          transition: 'max-height 200ms ease, opacity 200ms ease',
          maxHeight: isCollapsed ? 0 : 500,
          opacity: isCollapsed ? 0 : 1,
          marginTop: isCollapsed ? 0 : 8
        }}
      >
        <div style={{ marginBottom: 8, textAlign: 'center' }}>
          {t('note_templates.create_guidance_customize_prefix')}{' '}
          <Link onClick={onSwitchToStandard} style={{ color: 'var(--main-color)' }}>{t('note_templates.standard_note_phrase')}</Link>{' '}
          {t('note_templates.create_guidance_customize_suffix')}
        </div>
        <Divider plain style={{ margin: '8px 0' }}>
          {t('sign_in.fields.or')}
        </Divider>
        <TemplateUploadCTA onNewTemplate={onNewTemplate} />
      </div>
    </Card>
  );
}


